import {
  MdEdit,
  MdDelete,
  MdVisibility,
  MdPeople,
} from "react-icons/md";
import getImageUrl from "../../../../../../utils/imageUrl";
import "./CateringCard.css";

function CateringCard({
  packageData,
  onView,
  onEdit,
  onDelete,
}) {

    console.log("Package Image:", packageData.image);
  return (
    <div className="catering-card">

     {packageData.image &&
 packageData.image.trim() !== "" && (
  <img
    src={getImageUrl(`/uploads/${packageData.image}`)}
    alt={packageData.packageName}
    onError={(e) => {
      e.target.style.display = "none";
    }}
  />
)}

      <div className="catering-card-body">

        <h3>{packageData.packageName}</h3>

        <p>{packageData.category}</p>

        <h2>
          ₹{packageData.pricePerPlate}
          <span>/Plate</span>
        </h2>

        <div className="guest-info">

          <MdPeople />

          {packageData.minimumGuests} -
          {packageData.maximumGuests}

        </div>

        <div className="package-status">
          {packageData.isAvailable
            ? "Available"
            : "Unavailable"}
        </div>

        <div className="card-actions">

          <button
            onClick={() =>
              onView(packageData)
            }
          >
            <MdVisibility />
          </button>

          <button
            onClick={() =>
              onEdit(packageData)
            }
          >
            <MdEdit />
          </button>

          <button
            onClick={() =>
              onDelete(packageData)
            }
          >
            <MdDelete />
          </button>

        </div>

      </div>

    </div>
  );
}

export default CateringCard;